import PropTypes from "prop-types"
import Header from "./Header"

export default function Form({ name, description }) {
  return (
    <div>
      <Header name={name} description={description} />
    </div>
  )
}

Form.propTypes = {
  name: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
}
